<template>
  <div>
    <VueEasyLightbox
        :visible="visibleRef"
        :imgs="imgsRef"
        :index="indexRef"
        @hide="onHide"
    />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useAppStore } from '@/stores/appStore'
import VueEasyLightbox from 'vue-easy-lightbox'

const appStore = useAppStore()

const indexRef = ref(0)

const visibleRef = computed(() => appStore.lightbox.visible)
const imgsRef = computed(() => appStore.lightbox.images)

function onHide() {
  appStore.toggleLightbox(false)
}
</script>
